import type { QueryClient } from "@tanstack/react-query";
import type { Service } from "../types/serviceTypes";
import { compareServiceOrder } from "../utils/serviceOrder";

export const serviceKeys = {
  all: ["service"] as const,
  catalogue: (userId: string | undefined, businessId: string | undefined) =>
    [...serviceKeys.all, userId, businessId] as const,
};

export async function updateServiceCatalogue(
  queryClient: QueryClient,
  queryKey: ReturnType<typeof serviceKeys.catalogue>,
  update: (services: Service[]) => Service[]
) {
  if (!queryClient.getQueryState(queryKey)) return;

  await queryClient.cancelQueries({ queryKey, exact: true });
  const services = queryClient.getQueryData<Service[]>(queryKey);
  if (services) {
    queryClient.setQueryData(queryKey, update(services));
  } else {
    // A first load interrupted by a write must restart, not become a partial catalogue.
    await queryClient.invalidateQueries({ queryKey, exact: true });
  }
}

export function upsertService(services: Service[], service: Service): Service[] {
  return [...services.filter((item) => item.id !== service.id), service].sort(
    compareServiceOrder
  );
}
